import { render } from "./CemiterioPrevida.vue?vue&type=template&id=5c7efc22"
import script from "./CemiterioPrevida.vue?vue&type=script&lang=js"
export * from "./CemiterioPrevida.vue?vue&type=script&lang=js"

import "./CemiterioPrevida.vue?vue&type=style&index=0&id=5c7efc22&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__